import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule, } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
let Role = class Role extends VuexModule {
    selectedRow = [];
    organization = {};
    async getRoles(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/user-management/api/v1/ums/role/list',
                params: {},
                data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getRoleTree() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/user-management/api/v1/ums/role/tag/list',
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getPermissions() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/user-management/api/v1/ums/role/user/permissions',
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async createRole(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/user-management/api/v1/ums/role',
                data: data,
            });
        }
        catch (e) {
            throw e;
        }
    }
    async getRoleDetail(id) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/user-management/api/v1/ums/role/${id}`,
            });
            console.log('res:', res);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updateRoleDetail(data) {
        try {
            const res = await ajax.request({
                method: 'PUT',
                url: `/api/user-management/api/v1/ums/role`,
                data: data,
            });
            console.log('res:', res);
        }
        catch (e) {
            throw e;
        }
    }
    async deleteRole(id) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/user-management/api/v1/ums/role/${id}`,
            });
        }
        catch (e) {
            throw e;
        }
    }
    async getAllRoles() {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/user-management/api/v1/ums/role/list/all`,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    updateSelectedRow(payload) {
        this.selectedRow = payload;
    }
};
__decorate([
    Action({ rawError: true })
], Role.prototype, "getRoles", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "getRoleTree", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "getPermissions", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "createRole", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "getRoleDetail", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "updateRoleDetail", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "deleteRole", null);
__decorate([
    Action({ rawError: true })
], Role.prototype, "getAllRoles", null);
__decorate([
    Mutation
], Role.prototype, "updateSelectedRow", null);
Role = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/role' })
], Role);
export const RoleModule = getModule(Role);
